export default __webpack_public_path__ + "static/frame4-6d88b5ff6d89c91906b8174d31afa390.png";